import { React, useEffect, useRef, useState } from "react";

import { Button, Modal } from "react-bootstrap";
import "./UploadDocument.scss";
import FontUploadIcon from "../../images/font-upload.svg";
import LibrarySearchIcon from "../../images/library-searchIcon.svg";

import {
  deleteUploadedDocument,
  getUploadDocumentlist,
  uploadDocumentFiles,
  uploadLink,
} from "../../services/apis";
import { useDropzone } from "react-dropzone";
import CustomTooltip from "../Tooltip/Tooltip";
import { showErrorToast, showSuccessToast } from "../toastComponent/ToastComponent";

export const UploadDocument = (props) => {
  const { openDocumentModal, setOpenDocumentModal, deckId, editor } = props;
  const [totalFile, setTotalFIle] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [removeData, setRemoveData] = useState();
  const [checkedRadio, setCheckedRadio] = useState();
  const [uploadedDocument, setUploadedDocument] = useState([]);
  const [previousState, setPreviousState] = useState(null);
  const textElementRef = useRef();

  useEffect(() => {
    getUploadedDocumentlist();
  }, [uploadedDocument]);

  const onDrop = (acceptedFiles, rejectedFiles) => {
    // debugger;
    if (acceptedFiles.length) {
      const formData = new FormData();
      const file = acceptedFiles[0];

      if (file.size > 5242880) {
        showErrorToast('PDF upload failed, cannot upload PDF of size more than 5MB.');
      } else {
        formData.append("file", file);
        uploadDocumentFiles(deckId, formData, (response, error, errorCode) => {
          if (error) {
            showErrorToast('Upload Failed. Invalid file name.');
          } else {
            showSuccessToast('PDF added successfully.');
            setUploadedDocument(response?.data?.response?.uploadedDoc);
          }
        });
      }
    } else {
      showErrorToast('Please select correct file format.');
    }
  };

  const { getRootProps, getInputProps, isDragActive, acceptedFiles } =
    useDropzone({
      onDrop,
      accept: {
        "application/pdf": [".pdf"],
      },
    });

  const getUploadedDocumentlist = () => {
    getUploadDocumentlist(deckId, (response, err, errCode) => {
      if (err) {
      } else {
        const data = response.data.response;
        if (data) {
          setTotalFIle(data?.uploadedDoc);

          let findDoc = data?.uploadedDoc.filter((pdfData) => {
            if (pdfData.link === editor?.getSelected()?.getAttributes().href)
              return pdfData._id;
          });
          setPreviousState(findDoc[0]._id);

          setCheckedRadio(findDoc[0]);
        }
      }
    });
  };

  const handler = (e, value) => {
    if (checkedRadio?._id === value._id) {
      setCheckedRadio();
    } else {
      setCheckedRadio(value);
    }
  };

  const removeHandler = (value) => {
    setRemoveData(value);
  };

  const deleteHandler = (type, value) => {
    if (type === "yes") {
      const deleteId = value._id;
      // const copy = totalFile.filter(list => list._id !== removeData._id);
      // const remainingPdfId = copy.map(pdf => pdf._id);
      // console.log(copy, 'coyyyyyy', remainingPdfId)

      if (checkedRadio && checkedRadio?._id === value._id) {
        setCheckedRadio(null);
        editor
          .getSelected()
          .getTrait("href")
          .el.querySelector(".hrefInput").value = "";
        editor.getSelected().set("attributes", { href: "" });
      }

      deleteUploadedDocument(deckId, deleteId, (response, err, errCode) => {
        if (err) {
        } else {
          const data = response.data.response;
          setTotalFIle(data.uploadedDoc);
        }
      });
      setRemoveData();
    } else {
      setRemoveData();
    }
  };

  const linkURL2Comp = (checkedRadio) => {
    let payLoad = {
      prevLinkedDoc: previousState !== checkedRadio._id ? previousState : null,
      deckId: deckId,
      docId: checkedRadio._id,
      linkType: "link",
      type: "pdf",
    };
    //editor.getSelected().getTrait("href").set("value", checkedRadio.link);
    editor.getSelected().getTrait("href").el.querySelector(".hrefInput").value =
      checkedRadio.link;
    let attribute = editor.getSelected().getAttributes();
    editor.getSelected().set("attributes", {
      href: checkedRadio.link,
      Title: attribute.Title,
      target: attribute.target || "false",
    });
    setOpenDocumentModal(false);
    uploadLink(payLoad, (response, err, errCode) => {
      if (err) {
      } else {
        const data = response.data.response;

        // editor.getSelected().set("attributes", { href: checkedRadio.link });
        setOpenDocumentModal(false);
      }
    });
  };
  const cancelPdf = () => {
    setOpenDocumentModal(false);
    // let findDoc = totalFile.filter((pdfData) => {
    //     if (pdfData.link === editor?.getSelected()?.getAttributes().href)
    //       return pdfData;
    //   });

    //   setCheckedRadio()
  };
  return (
    <Modal
      show={openDocumentModal}
      fullWidth={true}
      size="lg"
      centered
      className="upload-doc-link"
    >
      <Modal.Header className="upload-document-header">
        <Modal.Title className="upload-doc-link-header">
          Upload Document Link
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="upload-document-body">
        <div className="d-flex upload-document-file">
          <div {...getRootProps({ className: "dropzone" })}>
            <input {...getInputProps} className="choose-document-upload-file" />
            <label for="uploadBtn" className="choose-document-upload-label">
              <img src={FontUploadIcon} />
              <span>Choose File</span>
            </label>
          </div>
          <div className="uploaded-document-search-main">
            <img
              alt="search"
              src={LibrarySearchIcon}
              className={"uploaded-document-search-image"}
            />
            <input
              value={inputValue}
              id="document-search-field"
              type="text"
              name="uploaded-document-search-field"
              onChange={(e) => setInputValue(e.target.value)}
              autoComplete="off"
              required
            />
            {!inputValue && (
              <div
                className="document-search-field-placeholder"
                htmlFor="document-search-field"
              >
                <span>
                  {" "}
                  Search by <span> `Document Name`</span>
                </span>
              </div>
            )}
          </div>
        </div>
        <div className="" style={{ height: "359px" }}>
          <ul className="uploaded-document-file">
            {totalFile
              .filter((list) =>
                inputValue.toLowerCase() === ""
                  ? list
                  : list.name.toLowerCase().includes(inputValue.toLowerCase())
              )
              .map((list) => {
                return (
                  <li className="d-flex uploaded-document-list">
                    <input
                      type="radio"
                      className="uploaded-doc-checkbox"
                      name={list.title}
                      value={list._id}
                      checked={checkedRadio?._id === list?._id ? true : false}
                      onClick={(e) => handler(e, list)}
                    />
                    <span className="uploaded-document-file-name">
                      <CustomTooltip
                        title={list?.name}
                        classes="upload-doc-tooltip"
                      >
                        <span className="uploaded-file-list">{list.name}</span>
                      </CustomTooltip>
                    </span>
                    <span
                      className={`removed-uploaded-document-file ${
                        removeData?._id === list?._id
                          ? "text-overlay"
                          : "removed-overlay"
                      }`}
                    >
                      {removeData && removeData._id === list._id ? (
                        <span>
                          <span className="areyousure">Any existing links will be impacted. Are you sure?
                          </span>
                          <span
                            className="yes"
                            onClick={() => deleteHandler("yes", list)}
                          >
                            Yes
                          </span>
                          <span
                            className="no"
                            onClick={() => deleteHandler("no")}
                          >
                            No
                          </span>
                        </span>
                      ) : (
                        <span onClick={() => removeHandler(list)}>Remove</span>
                      )}
                      {/* {!remove && } */}
                    </span>
                  </li>
                );
              })}
          </ul>
        </div>
      </Modal.Body>
      <Modal.Footer className="upload-document-footer">
        <Button
          variant="secondary"
          className="cancel-upload-document"
          onClick={() => {
            cancelPdf();
          }}
        >
          CANCEL
        </Button>
        <Button
          variant="primary"
          className="link-uploaded-document"
          disabled={!checkedRadio}
          onClick={() => {
            linkURL2Comp(checkedRadio);
          }}
        >
          LINK
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
